export const environment = {
  production: false,
  apiUrl: '/api/v1',
  tenantId: '517a9b45-59de-4915-9e97-6e0b30b5a85d',
  stripeKey: 'pk_test_123',
  stripePublishableKey: 'pk_test_51QzALYKHAWVilVtGJJozg8uXNlamAt9QGUDlS9NScqiYjoQFxNH88mUXDgUxBLMt0WKu5eIRmpqF8KxhESHYg9wb00FWIxzRS1',
};
